import { gql } from '@apollo/client'

// Recruiter job-area alerts (SPT-2331), Maestro schema only. Selections stay inline: addTypename is off in this app.
export const JOB_AREA_ALERT_FIELDS = `
	id name cities radiusMiles enabled createdAt updatedAt
	locations { name stateCode lat lng }
`

// Whether the tenant has job alerts switched on: shows the account-menu entry and guards the screens.
export const JOB_AREA_ALERTS_ENABLED_QUERY = gql`
	query jobAreaAlertsEnabled {
		jobAreaAlertsEnabled
	}
`

// The signed-in recruiter's own alerts, newest first.
export const JOB_AREA_ALERTS_QUERY = gql`
	query jobAreaAlerts {
		jobAreaAlerts {
			${JOB_AREA_ALERT_FIELDS}
		}
	}
`
